exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family='Frank Ruhl Libre',Georgia,serif);", ""]);

// Module
exports.push([module.id, "html,\nbody {\n  box-sizing: border-box;\n  height: 100%;\n  min-height: 100%;\n  font-family: Helvetica, 'Frank Ruhl Libre', Georgia, serif;\n  background: #fff;\n}\n\n#root {\n  box-sizing: border-box;\n  height: 100%;\n  height: 100vh;\n}\n", ""]);

